export default "__VITE_ASSET__BzkceVUF__"